import { ApiError } from '../api/client'

/** An API failure as staff read it: the server's detail when it sent one, else the status or a connection hint. */
export function apiErrorText(err: unknown, sending = false): string {
  if (err instanceof ApiError) {
    const d = err.detail as { detail?: unknown } | null
    if (d && typeof d.detail === 'string') return d.detail
    // A coded refusal: { detail: { message, code } } (the desk passes schedule gates on this way).
    const msg = d && d.detail && typeof d.detail === 'object' ? (d.detail as { message?: unknown }).message : undefined
    if (typeof msg === 'string' && msg) return msg
    return sending ? `Not sent (error ${err.status}).` : `That didn't work (error ${err.status}).`
  }
  return sending
    ? 'Not sent. Check your connection and try again.'
    : "That didn't work. Check your connection and try again."
}
